/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorBinary extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorBinary");
    }

    getFixupPrototypeFunction() { return QueryOperatorBinary.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorBinary>): QueryOperatorBinary {
        let obj = Object.assign(new QueryOperatorBinary(), model);
        QueryOperatorBinary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorBinary>): QueryOperatorBinary {
        if (!model) return null;
        return QueryOperatorBinary.newInstance(<QueryOperatorBinary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorBinary) {
        if (!obj) return;

        models.QueryOperatorBinary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorBinary): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorBinary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.a) {
            models.QueryOperator.fixupPrototype(this.a);
        }
        if (this.b) {
            models.QueryOperator.fixupPrototype(this.b);
        }
    }

    /**
     * Left side of binary query operator
     */
    a: models.QueryOperator;

    /**
     * Right side of binary query operator
     */
    b: models.QueryOperator;

}
